import { Injectable } from '@angular/core';
import { Currency } from '../currency';
import { PaymentToSupplier } from '../payment-to-supplier';
import { PaymentType } from '../payment-type';

@Injectable({
  providedIn: 'root'
})
export class PaymentToSupplierService {

  currencies: Currency[] = [];
  paymentTypes: PaymentType[] = [];
  selectedPayemnt!: PaymentToSupplier;
  payments: PaymentToSupplier[] = [];

  constructor() { }
}
